export const AppStorageKeys = {
  userAccessToken: "userAccessToken",
  entAuthRefereshToken: "entAuthRefereshToken",
  userName: "userName",
  userId: "userId",
  userEmail: "userEmail",
  profilePic: "profilePic",
  primaryRole: "primaryRole",
  userTitle: "userTitle",
  workingRole: "workingRole",
  isMCIverified: "isMCIverified",
  loginDate: "loginDate",
  profileCompleted: "profileCompleted",
  widgetId: "widgetId",
  widgetType: "widgetType",
  lastViewPoint: "lastViewPoint",
  uploadMCIReminderDate: "uploadMCIReminderDate",
  uploadMCIReminded: "uploadMCIReminded",
  registrationSourceCode: "registrationSourceCode",
};

const CryptoJS = require("crypto-js");

class LocalStorage {
  get = (key, parseJson) => {
    let data = localStorage.getItem(key) || null;
    if (data && parseJson) {
      data = JSON.parse(data);
    }
    return data;
  };
  save = (key, data) => {
    localStorage.setItem(key, JSON.stringify(data));
  };
  deleteItem = (key) => {
    localStorage.removeItem(key);
  };
  deleteAll = () => {
    for (const key in AppStorageKeys) {
      localStorage.removeItem(key);
    }
    // localStorage.clear();
  };
}
export const AppLocalStorage = new LocalStorage();

class SessionStorage {
  get = (key, parseJson) => {
    let data = sessionStorage.getItem(key) || null;
    if (data && parseJson) {
      data = JSON.parse(data);
    }
    return data;
  };
  save = (key, data) => {
    sessionStorage.setItem(key, JSON.stringify(data));
  };
  deleteItem = (key) => {
    sessionStorage.removeItem(key);
  };
  deleteAll = () => {
    sessionStorage.clear();
  };
}

export const AppSessionStorage = new SessionStorage();

export const capitalizeFirstCharacter = (s) => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const capitalizeAll = (s) => {
  if (typeof s !== "string") return "";
  const str = s.toLowerCase().split(" ");
  for (let i = 0; i < str.length; i++) {
    str[i] = capitalizeFirstCharacter(str[i]);
  }
  return str.join(" ");
};

const ENCRYPTION_KEY = "0z74P67WdkoeKXCc";

export const decryptContent = (s) => {
  let key = CryptoJS.enc.Base64.parse(btoa(ENCRYPTION_KEY));
  let decrypted = CryptoJS.AES.decrypt(s.replaceAll("\n", ""), key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};

export const BG_COLOR = {
  CME: "#2B3D47",
  WEBINAR: "#FFFFFF",
};

export const SIDE_BAR_COLOR = {
  CME: "#445863",
  WEBINAR: "#F9F9F9",
};

export const WIDGET_TYPE = {
  COURSE: "COURSE",
  CHAPTER: "CHAPTER",
  EPISODE: "EPISODE",
};

export const FELLOWSHIP_RATING_THRESHOLD = 3.5;
export const FELLOWSHIP_BATCH_FILLING_THRESHOLD = 70;

export const STREAMING_TYPE_ENUM = {
  YOUTUBE: 1,
  ZOOM: 2,
  EXTERNAL_LINK: 3,
};
